export default "__VITE_ASSET__MKewvWPx__"